import React from 'react';
import _ from 'lodash';
import TextInput from '../../../../core/web/js/form/TextInput';
import {change} from '../../../../core/web/js/form/FormUtil';
import AddButton from '../../../../core/web/js/button/Add';
import EditButton from '../../../../core/web/js/button/Edit';
import DeleteButton from '../../../../core/web/js/button/Delete';
import ResetButton from '../../../../core/web/js/button/Reset';
import CharacterView from './levelCharacter/CharacterView';
import ConfirmPrompt from '../../../../core/web/js/prompt/ConfirmPrompt';
import ErrorMessage from '../../../../core/web/js/message/Error';
import {closeMessage} from '../../../../core/web/js/message/MessageUtil';

import DynamicTable from '../../../../core/web/js/table/DynamicTable';
import {updateSort, updateColumnViewOrder, updateFilter, updateSelectionString} from '../../../../core/web/js/table/TableUtil';
import soldierColumns from '../../json/soldierColumns.json';

import '../../css/crew.css';


/**
 *
 */
function Crew(props){
  return (
    <div className="crew">
      <ConfirmPrompt
        confirmDisplay={props.state.confirmDisplay}
        message={props.state.confirmMessage}
        confirmClick={_confirmClick.bind(this, props, 'confirmDisplay')}
        cancelClick={_cancelConfirmClick.bind(this, props, 'confirmDisplay')}
      />
      <div className="content">
        <div className="name">
        <TextInput
          label={"Crew Name"}
          value={props.state.name}
          change={change.bind(this, props, 'name')}
        />
        </div>
        <h2 className="crewName">{props.state.name}</h2>
        {_renderCaptain(props)}
        <br />
        {_renderFirstMate(props)}
        <br />
        {_renderSoldiers(props)}
      </div>
      <div className="actionPane">
        <ResetButton title="Reset Crew" onClick={_resetCrew.bind(this, props)}>Reset Crew</ResetButton>
      </div>
    </div>
  );
}


/**
 *
 */
function _resetCrew(props){
  props.updateState(props.stateName, {"confirmDisplay":"open", "confirmMessage":"Data will be lost - Reset Crew?"});
}


/**
 *
 */
function _confirmClick(props){
  props.resetState(props.stateName)
}


/**
 *
 */
function _cancelConfirmClick(props){
  props.updateState(props.stateName, {"confirmDisplay":"closed", "confirmMessage":""});
}


/**
 *
 */
function _renderCaptain(props){
  if(!props.state.captain){
    return (
      <div className="captain">
        <AddButton type="secondary"  onClick={_addCaptain.bind(this,props)}>Add Captain</AddButton>
      </div>
    );
  }else{
    return (
      <CharacterView title="Captain" data={props.state.captain} />
    );
  }
}


/**
 *
 */
function _renderFirstMate(props){
  if(!props.state.firstMate){
    return (
      <div className="firstMate">
        <AddButton type="secondary" onClick={_addFirstMate.bind(this,props)}>Add First Mate</AddButton>
      </div>
    );
  }else{
    return (
      <div className="firstMate">
      <CharacterView title="First Mate" data={props.state.firstMate} />
      </div>
    );
  }
}


/**
 *
 */
function _renderSoldiers(props){
  const soldierCosts = props.state.soldiers.reduce((counter,soldier)=>{
    return counter+=soldier.cost;
  },0);

  const specialists = props.state.soldiers.filter(soldier=>soldier.type==='Specialist');
  return (
    <div className="crewList">
      <ErrorMessage message={props.state.errorMessage}
        close={closeMessage.bind(this,props,'errorMessage')}
        duration={5000}
      />
      {_renderSoldierTable(props)}
      Credits - {props.state.credits - soldierCosts}
      &nbsp;
      Specialist Slots - {4 - specialists.length}<br />
      <AddButton type="secondary" onClick={_addSoldier.bind(this,props)}>Add Soldier</AddButton>
      {_renderDeleteButton(props)}

    </div>
  );
}


/**
 *
 */
function _renderDeleteButton(props){
    if(props.state.soldiers.length){
      return (
        <React.Fragment>
        <EditButton title="Edit Soldier" onClick={_EditSoldier.bind(this, props)}>Edit</EditButton>
        <DeleteButton className="delete" onClick={_removeSoldier.bind(this, props)} >Remove</DeleteButton>
        </React.Fragment>
      );
    }else{
      return null;
    }
}

/**
 *
 */
function _EditSoldier(props){
  if(props.state.selection.length > 0){
    let data = props.state.soldiers.filter(soldier=>soldier.name===props.state.selection[0])[0];

    props.updateState('soldier', {
      "editSoldier":_editSoldierSuccess.bind(this, props, props.state.selection[0]),
      "cancelCreate":_cancelCreate.bind(this, props),
      ...data
    });
    window.location = '#soldier';

  }else{
    props.updateState(props.stateName, {"errorMessage": "Please select a soldier to edit."})
  }
}

/**
 *
 */
function _editSoldierSuccess(props, oldName, data){
  let custom = _.cloneDeep(props.state.soldiers).map(soldier=>{
    if(soldier.name===oldName){
      soldier = Object.assign(soldier, data);
    }
    return soldier;
  });


  let state = _.cloneDeep(props.state);
  state.soldiers = custom;

  let resetStates = [
    {"id":"soldier"},
    {"id":props.stateName, "mixin":state}
  ];
  props.resetMultiple(resetStates);
  window.location = '#' + props.stateName;

}


/**
 *
 */
function _cancelCreate(props){
  props.resetState('soldier');
  window.location = '#' + props.stateName;
}

/**
 *
 */
function _removeSoldier(props){
  if(props.state.selection.length === 0){
    props.updateState(props.stateName, {'errorMessage': "Please select a soldier to remove."})
  }else{
    const soldiers = props.state.soldiers.filter(soldier=>soldier.name !== props.state.selection[0]);
    props.updateState(props.stateName, {"soldiers":soldiers});
  }
}


/**
 *
 */
function _renderSoldierTable(props){
  if(props.state.soldiers.length){
    const renderer = {
      "move":_renderNumber,
      "fight":_renderNumberSign,
      "shoot":_renderNumberSign,
      "armor":_renderNumber,
      "will":_renderNumberSign,
      "health":_renderNumber,
      "cost":_renderNumber
    };
    return(
      <React.Fragment>
        <div className="header"><span className="characterName">Soldiers</span></div>
        <DynamicTable
          caption={props.caption||null}
          columns={soldierColumns}
          rows={props.state.soldiers}
          render={renderer}

          selection={props.state.selection}
          updateSelection={updateSelectionString.bind(this, props, 'selection')}

          sort={props.state.sort}
          updateSort={updateSort.bind(this, props, 'sort')}

          filter={props.state.filter}
          updateFilter={updateFilter.bind(this, props, 'filter')}

          columnView={props.state.columnView}
          columnOrder={props.state.columnOrder}
          updateColumnView={updateColumnViewOrder.bind(this, props, 'columnView', 'columnOrder')}
        />
      </React.Fragment>
    );
  }else{
    return null;
  }
}


/**
 *
 */
function _renderNumber(data, row){
    return (<div className="number">{data}</div>);
}


/**
 *
 */
function _renderNumberSign(data, row){
  if(data>0){
    return (<div className="number">+{data}</div>);
  }else{
    return (<div className="number">{data}</div>);
  }
}


/**
 *
 */
function _addCaptain(props){
  props.updateState("captain",{"addRoster":_addCaptainSuccess.bind(this, props)});
  window.location = '#captain';
}


/**
 *
 */
function _addCaptainSuccess(props, data){
  props.updateState(props.stateName, {"captain": data});
  window.location = '#'+props.stateName;
}


/**
 *
 */
function _addFirstMate(props){
  props.updateState("firstmate",{"addRoster":_addFirstMateSuccess.bind(this, props)});
  window.location = '#firstmate';
}


/**
 *
 */
function _addFirstMateSuccess(props, data){
  props.updateState(props.stateName, {"firstMate": data});
  window.location = '#'+props.stateName;
}


/**
 *
 */
function _addSoldier(props){
  const soldiersState = props.getState('soldiers');
  props.resetState("soldiers",{"addRoster":_addSoldierSuccess.bind(this, props), "custom": soldiersState.custom});
  window.location = '#soldiers';
}


/**
 *
 */
function _addSoldierSuccess(props, data){
  let soldiers = _.cloneDeep(props.state.soldiers);
  soldiers.push(data);

  let state = _.cloneDeep(props.state);
  state.soldiers = soldiers;

  const soldiersState = props.getState('soldiers');

  let resetStates = [
    {"id":"soldiers", "mixin":{"custom": soldiersState.custom}},
    {"id":props.stateName, "mixin":state}
  ];
  props.resetMultiple(resetStates);
  window.location = '#'+props.stateName;
}


export default Crew;
